module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "foot"
  }, [_c('div', {
    staticClass: "text-card"
  }, [_vm._v("撰写卡片...")]), _vm._v(" "), _c('a', {
    staticClass: "audio-input"
  }, [_c('label', {
    staticClass: "fa fa-microphone",
    attrs: {
      "for": "microphone",
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "id": "microphone",
      "type": "file",
      "accept": "audio/*;capture=microphone"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "camera-input"
  }, [_c('label', {
    staticClass: "fa fa-camera",
    attrs: {
      "for": "camera",
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "id": "camera",
      "type": "file",
      "accept": "image/*;capture=camera"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c8df9c5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footBar.vue
// module id = 52
// module chunks = 0